import { Model } from "@vuex-orm/core";
import config from "../configs/User";

export default class User extends Model {
  static get entity() {
    return "users";
  }
  static fields() {
    return {
      id: this.attr(null),
      username: this.attr(null),
      email: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      phone: this.attr(null),
      mediaId: this.attr(null),
      timezone: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
